import { Token } from '@sunwebgroup/uds-ui/token'
import { useCallback } from 'react'
import { useMultiSelectFilter } from '@/scopes/search/search/domain/hooks'

export function AirlineTokens() {
  const { isFetching, isLoading, selectedOptions, setSelection, selectedValues } = useMultiSelectFilter('Airline')

  const handleRemoveClick = useCallback(
    (value?: string) => {
      setSelection(selectedValues.filter(selectedValue => selectedValue !== value))
    },
    [selectedValues, setSelection],
  )

  if (isLoading)
    return null

  return selectedOptions.map(({ value, name }) => (
    <Token key={value} value={value} disabled={isFetching} dismissible onDismissClick={handleRemoveClick}>
      {name}
    </Token>
  ))
}
